"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
var mobx_1 = require("mobx");
var ProvinceProductFilter = /** @class */ (function () {
    function ProvinceProductFilter() {
    }
    ProvinceProductFilter.prototype.resetFilter = function () {
        this.name = undefined;
        this.sku = undefined;
        this.barcode = undefined;
    };
    ProvinceProductFilter.prototype.changeFilterParameter = function (key) {
        var existingFilter = this.filterString;
        this.resetFilter();
        this[key] = existingFilter;
    };
    Object.defineProperty(ProvinceProductFilter.prototype, "filterString", {
        get: function () {
            return this.name || this.sku || this.barcode;
        },
        enumerable: true,
        configurable: true
    });
    __decorate([
        mobx_1.observable
    ], ProvinceProductFilter.prototype, "name", void 0);
    __decorate([
        mobx_1.observable
    ], ProvinceProductFilter.prototype, "sku", void 0);
    __decorate([
        mobx_1.observable
    ], ProvinceProductFilter.prototype, "barcode", void 0);
    __decorate([
        mobx_1.action
    ], ProvinceProductFilter.prototype, "resetFilter", null);
    __decorate([
        mobx_1.action
    ], ProvinceProductFilter.prototype, "changeFilterParameter", null);
    __decorate([
        mobx_1.computed
    ], ProvinceProductFilter.prototype, "filterString", null);
    return ProvinceProductFilter;
}());
exports.ProvinceProductFilter = ProvinceProductFilter;
//# sourceMappingURL=ProvinceProduct.js.map